<script setup>
import {computed} from 'vue'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const isSiteTreePinned = computed(() => pageEditorStore.pinSiteTree)

const toggleSiteTreePin = () => {
    pageEditorStore.pinSiteTreeAction()
}
</script>

<template>
    <!-- :active-class="'btn-warning'" :active-value="isSiteTreePinned" -->
    <Button @click="toggleSiteTreePin" class="btn-sm">
        <i class="bi" :class="{'bi-pin': !isSiteTreePinned, 'bi-pin-angle-fill': isSiteTreePinned}"/>
    </Button>
</template>